var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger",class:{'is-active':_vm.isActive},on:{"click":_vm.click}},[_c('d2-el-icon',{attrs:{"name":"s-fold"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }